import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./Submit_Modal.css";
import Lottie from "react-lottie";
import * as animationData from "./Submit_Modal.json";

const Submit_Modal = ({ show, handleClose }) => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Modal
      show={show}
      // onHide={handleClose}
      centered
      className="success_modal_div"
    >
      <Modal.Body className="success_modal text-center">
        <div className="success_lottie">
          <Lottie className="me-auto lottie" options={defaultOptions} />
        </div>
        <h5>Send !!!</h5>
      </Modal.Body>
    </Modal>
  );
};

export default Submit_Modal;
